"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPathsFromData;

var _lodash = _interopRequireDefault(require("lodash.flattendeep"));

var _joinSeparator = _interopRequireDefault(require("../constants/joinSeparator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Building data object hierarchy */
function dataIsIgnored(data, ignorePattern) {
  return ignorePattern && new RegExp(ignorePattern).test(data);
}

function joinPaths(firstPath, secondPath) {
  if (!firstPath || !secondPath) {
    return firstPath || secondPath;
  }

  return `${firstPath}${_joinSeparator.default}${secondPath}`;
}

function getPathsFromData(data, substitutedKeys, ignorePattern, parentPath) {
  const paths = substitutedKeys.reduce((validPaths, substitutedKey) => {
    if (typeof substitutedKey === 'string') {
      return data && data[substitutedKey] && !dataIsIgnored(data[substitutedKey], ignorePattern) ? [...validPaths, joinPaths(parentPath, substitutedKey)] : validPaths;
    }

    if (!data) {
      return validPaths;
    }

    const nestedKey = getPathsFromData(data[substitutedKey.key], substitutedKey.subKeys, ignorePattern, joinPaths(parentPath, substitutedKey.key));

    if (!nestedKey.length) {
      return validPaths;
    }

    return [...validPaths, nestedKey];
  }, []).filter(Boolean);
  return (0, _lodash.default)(paths);
}